import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EProductTypes, IProductData } from './types';
import { sortProducts } from './utils';

export interface ISubscribePageState {
  started: boolean;
  products: IProductData[];
}

export const initialState: ISubscribePageState = {
  started: false,
  products: [
    {
      id: 1,
      name: ' ',
      type: EProductTypes.ONE_TIME_PAYMENT,
      recommended: false,
      coupon: null,
    },
    {
      id: 2,
      name: ' ',
      type: EProductTypes.ONE_TIME_PAYMENT,
      recommended: true,
      coupon: null,
    },
    {
      id: 3,
      name: ' ',
      type: EProductTypes.ONE_TIME_PAYMENT,
      recommended: false,
      coupon: null,
    },
  ],
};

export const statePropName = 'subscribe';

const subscribeSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    subscribeInit: (state: ISubscribePageState) => {
      state.started = true;
    },
    updateProducts: (state: ISubscribePageState, action: PayloadAction<IProductData[]>) => {
      state.products = action.payload.sort(sortProducts);
    },
    selectProduct: (state: ISubscribePageState, action: PayloadAction<number>) => {
      // handle success state if needed
    },
    openCheckout: (state: ISubscribePageState, action: PayloadAction<number>) => {
      // handle success state if needed
    },
    productsRequest: (state: ISubscribePageState, action: PayloadAction<string | undefined>) => {
      // handle success state if needed
    },
    productsRequestSuccess: (state: ISubscribePageState) => {
      // handle success state if needed
    },
    productsRequestFail: (state: ISubscribePageState, action: PayloadAction<string | undefined>) => {
      // handle fail state if needed
    },
  },
});

export const SubscribeActions = subscribeSlice.actions;

export default subscribeSlice.reducer;
